<template>
    <div class="TxProductAdminPortal" v-if="$root.env === 'admin'">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "TxProductAdminPortal",
        mounted() {
            if (this.$root.env === 'admin') {
                document.body.querySelector('#lovemap-admin').appendChild(this.$el);
            }
        },
        beforeDestroy() {
            if (this.$root.env === 'admin') {
                this.$el.remove();
            }
        }

    }
</script>

<style scoped>

</style>